import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FournisseurDTO } from '../../customs/_models/FournisseurDTO';
import { emplacementDTO } from '../../customs/_models/emplacementDto';

@Injectable({
  providedIn: 'root'
})
export class EmplacementService {

  private apiUrl = environment.base_url + '/api/emplacement';

  constructor(private http: HttpClient) {}

  // 🔹 Créer un nouveau fournisseur
  createEmplacement(fournisseur: emplacementDTO): Observable<emplacementDTO> {
    return this.http.post<emplacementDTO>(this.apiUrl, fournisseur, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  // 🔹 Modifier un fournisseur existant
  updateEmplacement(id: number, fournisseur: emplacementDTO): Observable<emplacementDTO> {
    return this.http.put<emplacementDTO>(`${this.apiUrl}/${id}`, fournisseur, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  // 🔹 Récupérer tous les fournisseurs (avec flag = true côté backend)
  getAllEmplacements(): Observable<emplacementDTO[]> {
    return this.http.get<emplacementDTO[]>(this.apiUrl);
  }

  // 🔹 Récupérer un fournisseur par son ID
  getEmplacementById(id: number): Observable<emplacementDTO> {
    return this.http.get<emplacementDTO>(`${this.apiUrl}/${id}`);
  }

  // 🔹 Suppression logique (soft delete)
  deleteEmplacement(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
